const ferries = {
  ferry: "Ferry",
  ferries: "Ferries",
  selectOriginPort: "Select the origin Port",
  selectDestPort: "Select the destination Port",
  continue: "Continue",
  viewTimetables: "View Timetables",
  operator: "Operator",
  cabin: "Cabin",
  cabins: "Cabins",
  place: "Place",
  places: "Places",
  seat: "Seat",
  seats: "Seats",
  seating: "Seating",
  deckSpace: "Deck Space",
  compulsory: "compulsory",
  departure: "Departure",
  total: "Total",
  back: "Back",
  next: "Next",
  duration: "Duration",
  return: "Return",
  prebook: "Prebook",
  travelInfo: "Travel Info",
  book: "Book",
  adults: "Adults",
  child: "Child",
  seniors: "Seniors",
  senior: "Senior",
  to: "to",
  passenger: "Passenger",
  details: "Details",
  currencyForTickets: "The currency for these tickets will be",
  seatsError: "The number of passengers is not equal to the capacity.",
  title: "Title",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  phone: "Phone",
  dateOfBirth: "Date of Birth",
  placeOfBirth: "Place of Birth",
  groupLeader: "Group Leader",
  isRequired: "Is required",
  charactersOnly: "Characters Only",
  latinCharactersAndSpacesOnly: "Latin Characters and Spaces Only",
  validEmail: "Not a valid email",
  atLeastOneAdult: "At least 1 adult is required.",
  atLeastOneSenior: "At least 1 senior is required.",
  toastAlert: "Please correct all errors in the forms below.",
  backToFerriesList: "Back to Ferries List",
  bestPrice: "Best Price",
  fastest: "Fastest",
  beforeDeparture: "Before Departure",
  perPerson: "per person",
  notAvailableForOnlineBooking: "Not available for online booking",
  hurryLimitedAvailability: "Hurry up! Limited availability",
  berth: "Berth",
  berths: "Berths",
  sumOfSelectionNotEqualToPersons:
    "The sum of your selection is not equal to the number of passengers",
  attemptToBook: "You have attempted to book a total of",
  seatsWhenYouHave: "seats when you have",
  passengersTravelling: "passengers travelling",
  withReturn: "with return tickets",
  pleaseCorrectYourSelection: "Please correct your selection",
  pleaseSelectUpTo: "Please select up to",
  accommodationTypes: "accommodation types",
  selectionPrices: "Selection Prices",
  yourCurrentTicket: "Your current ticket type is",
  upgradeTo: "Upgrade to",
  wouldYouLikeToUpgrade: "Would you like to upgrade your ticket type?",
  backToTicketTypes: "Back to Ticket Types",
  originPort: "Origin Port",
  destinationPort: "Destination Port",
  outboundDate: "Outbound Date",
  inboundDate: "Inbound Date",
  passengers: "Passengers",
  hasReturn: "Has Return",
  passportNumber: "Passport Number",
  passportExpiryDate: "Passport Expiry Date",
  passportPlaceOfIssue: "Passport Place of Issue",
  passportStartDate: "Passport Start Date",
  cityCode: "City Code",
};

export default ferries;
